const getters = {
    candidateHeaders: state => state.candidateHeaders,
    ruleHeaders: state => state.ruleHeaders,
    data: state => state.data,
    pagination: state => state.pagination,
    parameterDataMap: state => state.parameterDataMap,
    columnFilterType: state => state.columnFilterType,
    loading: state => state.loading,
    isVisibleAddForm: state => state.isAddForm,
    selectedState: state => state.selectedState,
}

export default getters;